import React from "react";

const legendCardStyle = {
    border: "1px solid #e2e6ea",
    borderRadius: "0.375rem",
    margin: "1rem 0",
    padding:"5px"
}

const MapLegendCustomized = () => {
    return (
        <div className="my-2">
            <div style={legendCardStyle}>
                <b className="p-2">Berücksichtigte Verkehrsmittel</b>
                <div className="align-items-center justify-content-between d-flex pb-2">
                    <div className="d-inline-flex align-items-center px-1">
                        <img src="eisenbahn-icon.png" alt="eisenbahn-icon" />
                        <div className="px-1">Eisenbahn</div>
                    </div>
                    <div className="d-inline-flex align-items-center px-1">
                        <img
                            src="S-Bahn_Austria.png"
                            alt="SBahn-AT-icon"
                            style={{ width: "18px" }}
                        />
                        <div className="px-1">S-Bahn</div>
                    </div>
                    <div className="d-inline-flex align-items-center px-1">
                        <img
                            src="regionalbus-icon.png"
                            alt="regionalbus-icon"
                        />
                        <div className="px-1">Regionalbus</div>
                    </div>
                </div>
                <div className="align-items-center justify-content-start d-flex pb-2">
                    <div className="d-inline-flex align-items-center px-2">
                        <img src="stadtbus-icon.png" alt="stadtbus-icon" />
                        <div className="px-1">Stadtbus</div>
                    </div>
                    <div className="d-inline-flex align-items-center px-2">
                        <img
                            src="seil-zahnradbahn-icon.png"
                            alt="seil-zahnradbahn-icon"
                        />
                        <div className="px-1">Seil-/Zahnradbahn</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MapLegendCustomized;
